export default "__VITE_ASSET__1jG1Nz5h__"